import React from 'react';
import { Form, InputNumber, Input, Row, Col, Switch } from 'antd';
import { SectionHeader } from '../AirwayBillDetail';

const { TextArea } = Input;

const FinancialInfoSection = () => {
  return (
    <Row gutter={4} align="top">
      <Col span={2}>
        <SectionHeader>财务信息</SectionHeader>
      </Col>
      <Col span={22}>
        <Row gutter={4}>
          <Col span={6}>
            <Form.Item name="courier_fee" label="快递费用">
              <InputNumber style={{ width: '100%' }} />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item name="average_tax" label="平均税金">
              <InputNumber style={{ width: '100%' }} />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item name="taxed_package_count" label="出税包裹数量">
              <InputNumber style={{ width: '100%' }} />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item name="total_tax" label="总税金">
              <InputNumber style={{ width: '100%' }} />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={4}>
          <Col span={6}>
            <Form.Item name="additional_tax" label="补税金额">
              <InputNumber style={{ width: '100%' }} />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item 
              name="is_additional_tax_notes" 
              label="是否额外补税" 
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item 
              name="is_claim_package_notes" 
              label="是否理赔包裹" 
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item 
              name="is_processed" 
              label="账单已核对"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item
          noStyle
          shouldUpdate={(prevValues, currentValues) => 
            prevValues.is_additional_tax_notes !== currentValues.is_additional_tax_notes
          }
        >
          {({ getFieldValue }) => 
            getFieldValue('is_additional_tax_notes') && (
              <Row gutter={4}>
                <Col span={24}>
                  <Form.Item 
                    name="additional_tax_notes" 
                    label="额外补税"
                    labelCol={{ span: 2 }}
                    wrapperCol={{ span: 22 }}
                  >
                    <TextArea rows={3} style={{ fontSize: '12px', resize: 'none' }} />
                  </Form.Item>
                </Col>
              </Row>
            )
          }
        </Form.Item>

        <Form.Item
          noStyle
          shouldUpdate={(prevValues, currentValues) => 
            prevValues.is_claim_package_notes !== currentValues.is_claim_package_notes
          }
        >
          {({ getFieldValue }) => 
            getFieldValue('is_claim_package_notes') && (
              <Row gutter={4}>
                <Col span={24}>
                  <Form.Item 
                    name="claim_package_notes" 
                    label="理赔包裹"
                    labelCol={{ span: 2 }}
                    wrapperCol={{ span: 22 }}
                  >
                    <TextArea rows={3} style={{ fontSize: '12px', resize: 'none' }} />
                  </Form.Item>
                </Col>
              </Row>
            )
          }
        </Form.Item>
      </Col>
    </Row>
  );
};

export default FinancialInfoSection;
